import { startRequest, finishRequest } from "@store/utils";

export const onGetClientChangeLog = state => () => {
  return {
    ...state,
    changelog: {
      ...startRequest(state.changelog),
    },
  };
};

export const onGetClientChangeLogSuccess = state => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    changelog: {
      ...finishRequest(state.changelog),
      list: payload,
    },
  };
};

export const onGetClientChangeLogError = state => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    changelog: {
      ...finishRequest(state.changelog),
      list: {
        ...state.changelog.list,
        content: [],
      },
    },
  };
};
